import { render, staticRenderFns } from "./InsightCalculationTableFormatting.vue?vue&type=template&id=6d08aa7c&scoped=true&"
import script from "./InsightCalculationTableFormatting.vue?vue&type=script&lang=ts&"
export * from "./InsightCalculationTableFormatting.vue?vue&type=script&lang=ts&"
import style0 from "./InsightCalculationTableFormatting.vue?vue&type=style&index=0&id=6d08aa7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08aa7c",
  null
  
)

export default component.exports